// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tornadus_therian: PokeData = {
  "id": 10019,
  "name": "tornadus-therian",
  "height": 14,
  "weight": 630,
  "base_experience": 290,
  "types": [
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "thrash",
    "leer",
    "bite",
    "agility",
    "swagger",
    "rain-dance",
    "crunch",
    "uproar",
    "revenge",
    "astonish",
    "air-cutter",
    "extrasensory",
    "hammer-arm",
    "tailwind",
    "dark-pulse",
    "air-slash",
    "hurricane",
    "bleakwind-storm"
  ],
  "moves": [
    "gust",
    "leer",
    "bite",
    "rain-dance",
    "crunch",
    "tailwind",
    "dark-pulse",
    "air-slash",
    "hurricane",
    "sky-attack",
    "roost",
    "acrobatics",
    "aerial-ace"
  ],
  "evolution_chain": {
    "id": 328,
    "item": null,
    "species": [
      {
        "name": "tornadus",
        "order": 642,
        "types": [
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 105,
    "speed": 155,
    "ability_power": 141
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
